import {
    DestinationEvent,
    FormattedEvent,
    transformDestinationEvent,
} from '@eventbrite/event-renderer';
import { useContext, useEffect, useState } from 'react';
import { TrackingContext } from '../../context';
import { EventBasicInformationContext } from '../../contexts/EventContext';
import { searchEventRelatedPromotedEvents } from '../_shared/searchEventRelatedPromotedEvents';

export function usePromotedEvents() {
    // This can led to confussion since we are not tracking anything here
    // TODO: Replace this context with a specific function for feature flags
    // https://eventbrite.atlassian.net/browse/EB-225580
    const { featureFlags } = useContext(TrackingContext);
    const eventBasicInformation = useContext(EventBasicInformationContext);
    const [promotedEvents, setPromotedEvents] = useState<Array<FormattedEvent>>(
        [],
    );
    const [loaded, setLoaded] = useState(
        !featureFlags.enable_fe_placement_on_related_events,
    );

    useEffect(() => {
        if (
            !featureFlags.enable_fe_placement_on_related_events ||
            !eventBasicInformation?.id
        ) {
            return;
        }

        searchEventRelatedPromotedEvents(eventBasicInformation).then(
            (promotedEvents: Array<DestinationEvent>) => {
                setLoaded(true);
                setPromotedEvents(
                    promotedEvents.map(transformDestinationEvent),
                );
            },
        );
    }, [eventBasicInformation, featureFlags]);

    return { promotedEvents, loaded };
}
